<template>
<div>
    <template   v-for="(item, index) in BlogInputContent"
          
         >
        <b-row
            :id="item.id"
         :key="'content-'+index"
          ref="row"
          v-if="item.remove !== true"

        >
          <b-col md="2" class="mb-2"></b-col>
          <b-col md="8" class="text-right mb-2">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              
              @click="removeItem(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Delete</span>
            </b-button>
          </b-col>
          <b-col md="2" class="mb-2"></b-col>
          <b-col md="2">  
            <b-img
                v-if="item.layout_id == 1"
                :src="require('@/assets/images/blog/left.png')"
                height="110"
                width="170"
                class="rounded mr-2 mb-1 mb-md-0"
              />
              <b-img
                v-else-if="item.layout_id == 2"
                :src="require('@/assets/images/blog/right.png')"
                height="110"
                width="170"
                class="rounded mr-2 mb-1 mb-md-0"
              />
              <b-img
                v-else-if="item.layout_id == 3"
                :src="require('@/assets/images/blog/middle.png')"
                height="110"
                width="170"
                class="rounded mr-2 mb-1 mb-md-0"
              />

          </b-col>
          <b-col 
          md="8"
        
            
          >
          <b-form-group
                label="Layout"
                label-for="layout"
              >
            <v-select
           
                    v-model="item.layout_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="(option) => option.id"
                    :options="Layouts"
            />
            </b-form-group>
            
            <!--<b-form-group
                label="Image"
                label-for="image"
              >
              <b-card-text v-if="item.image" class="my-1">
                <b-img
                
                  :src="item.fullpath"
                 
                  width="100"
                  class="rounded mr-2 mb-1 mb-md-0"
                />
                <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-danger" v-if="item.image" @click="revomeImage(index)" >
                  <feather-icon
                    icon="XCircleIcon"
                   
                    class="text-danger"
                
                  />
                  Remove  
                  
                </b-button>
              </b-card-text>
              <b-form-file
              
             
              v-model="item.contentFile"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
             
              <b-card-text class="my-1">
                Selected file: <strong>{{ item.contentFile ? item.contentFile.name : '' }}</strong>
              </b-card-text>
        
                
              </b-form-group>-->
          </b-col>
          <b-col
            
            md="2"
           
          >
            
          </b-col>
          <b-col  md="2" class="mt-2" :class="item.show?'':''">
            
          </b-col>
          <b-col  md="8"  class="mt-2" :class="item.show?'':''">
            <b-tabs v-if="langs">
                <b-tab v-for="(lang,ind) in langs" :key="'section-content-'+index+'-'+ind" :title="lang.name">
                    <b-form-group
                        label="Title"
                        label-for="title"
                    >
              <b-form-input
               
                 v-model="item.title[lang.code]"
                 autofocus
                
                 trim
                 placeholder="Title"
               
               />
        
                
              </b-form-group>
              <b-form-group
                label="Description"
                label-for="description"
              >
              <quill-editor :options="editorOptions" v-model="item.description[lang.code]" />
                
              </b-form-group>
                </b-tab>
            </b-tabs>
           
           
            
             
              
          </b-col>
          <b-col  md="2"  class="mt-2" :class="item.show?'':'d-none'">
            
          </b-col>


          <!-- Remove Button -->
          
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
      </template>
      <b-row>
      <b-col md="2"></b-col>
      <b-col md="8" class="text-right"> <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="repeateAgain"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-25"
      />
      <span>Add New</span>
    </b-button></b-col>
      <b-col md="2"></b-col>
    </b-row>
</div>
    
</template>

<script>
import {
  BCard, BCardText, BFormFile, BForm, BFormGroup, BFormInput, BRow, BCol, BButton,BImg,BTabs,BTab
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'

import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
//import { slugify } from '@/@fake-db/utils'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)
export default {
components: {
    BCard,
    BCardText, BFormFile,

    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BImg,
    BTabs,
    BTab,
    vSelect,
    quillEditor,
    
  },
  directives: {
    Ripple,
  },
  model: {
     prop: 'BlogInputContent',
     prop: 'BlogInputContentRemove',
     event: 'update:blog-input-content',
     event: 'update::blog-input-content-remove'
   },
   props: {
    BlogInputContent: {
       type: Array,
       required: true,
     },
     BlogInputContentRemove: {
       type: Array,
       required: true,
     },
     langs:{
        type: Array,
        required:true
     },
     blogData: {
       type: Object,
       required: false,
     },
   },
   mixins: [heightTransition],
   computed: {
      editorOptions (){
        return $themeConfig.snowOption
      } 
    },
   setup(props, { emit }) {
    const Layouts = ref([
      {
        id:1,
        title:'Layout 1'
      },
      {
        id:2,
        title:'Layout 2'
      },
      {
        id:3,
        title:'Layout 3'
      },
    ]);
    
    //const BlogInputContent = ref(props.BlogInputContent);
    const nextTodoId = ref(props.BlogInputContent.length+1);
    
    const repeateAgain = ()=>{
      props.BlogInputContent.push({
          id:'',
          layout_id: 1,
          blog_id: '',
          image:'',
          title:{},
          description:{},
          show:true
          //id: nextTodoId.value += nextTodoId.value,
      });
      //emit('update:blog-input-repeater', BlogInputContent.value);
    } 
    const revomeImage = (key)=>{
        props.BlogInputContent[key].image = '';
     }
    const removeItem = (index)=>{
     
      
      if( props.BlogInputContent[index].id > 0){
        props.BlogInputContentRemove.push(props.BlogInputContent[index].id);
      }
      props.BlogInputContent.splice(index,1);
     /* if( props.BlogInputContent[index].id > 0){
        props.BlogInputContent[index].remove = true;
      }else{
        props.BlogInputContent.splice(index,1);
      }*/
     
     // emit('update:blog-input-repeater', BlogInputContent.value);
    }
   

    return {
      repeateAgain,
      nextTodoId,
      Layouts,
      removeItem,
      revomeImage,
    
    }
  },
}

</script>